import {
  FormPageInputItemSingleSelectionRadio,
  FormPageInputItemSingleSelectionPulldown,
} from 'shared';
import { SingleSelectionValueForValidation } from '../shared';

export const convertSingleSelectionPulldown = (
  inputValue: FormPageInputItemSingleSelectionPulldown
): SingleSelectionValueForValidation => {
  const { value } = inputValue;
  if (value == null) {
    return {
      value: undefined,
    };
  }
  return {
    value: Number(value),
  };
};

export const convertSingleSelectionRadio = (
  inputValue: FormPageInputItemSingleSelectionRadio
): SingleSelectionValueForValidation => {
  const { value, subtexts } = inputValue;
  if (value == null) {
    return {
      value: undefined,
    };
  }
  const subtext = subtexts?.find((text) => text.value === value);
  return {
    value: Number(value),
    subtext: subtext?.subtext,
  };
};
